import i18n from "i18n";

export const groupMessages = {
  create: i18n.t('notifications.group.create'),
  update: i18n.t('notifications.group.update'),
  delete: i18n.t('notifications.group.delete')
};
